import { type FC, type ReactNode, useEffect } from 'react';
import { ConfigContext } from './context';
import { activeConfig } from './index';

export const ConfigProvider: FC<{ children: ReactNode }> = ({ children }) => {
  useEffect(() => {
    const { theme, namespace, branding } = activeConfig;
    const root = document.documentElement;

    root.style.setProperty('--color-brand-primary', theme.colorPrimary);
    root.style.setProperty('--color-brand-secondary', theme.colorSecondary);
    root.style.setProperty('--color-brand-accent', theme.colorAccent);
    root.style.setProperty('--color-brand-highlight', theme.colorHighlight);
    root.style.setProperty('--color-brand-muted', theme.colorMuted);
    root.style.setProperty('--color-brand-light', theme.colorLight);

    root.setAttribute('data-namespace', namespace);

    const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (favicon) {
      favicon.href = branding.faviconHref;
      favicon.type = branding.faviconHref.endsWith('.ico')
        ? 'image/x-icon'
        : 'image/png';
    }
  }, []);

  return (
    <ConfigContext.Provider value={activeConfig}>
      {children}
    </ConfigContext.Provider>
  );
};
